import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const QUOTES = [
  {
    q: "RockLadder gave us the confidence that our security environment was being watched around the clock. Their team significantly improved our ability to identify and respond to security incidents.",
    a: "CIO",
    org: "Global Enterprise",
  },
  {
    q: "The CrowdStrike deployment significantly strengthened our endpoint visibility and our ability to respond to threats.",
    a: "CISO",
    org: "BFSI Organization",
  },
  {
    q: "Their team understood our environment, integrated the right technologies, and delivered without disrupting our operations.",
    a: "Head of IT",
    org: "Enterprise Organization",
  },
  {
    q: "We went from having fragmented security capabilities to a much clearer, more integrated security environment.",
    a: "Head of IT",
    org: "Manufacturing Organization",
  },
  {
    q: "The SOC team became an extension of our own security function, providing the 24×7 visibility and response capability we needed.",
    a: "CIO",
    org: "Technology Organization",
  },
  {
    q: "The Zscaler deployment gave our remote workforce secure, seamless access without compromising user experience.",
    a: "CIO",
    org: "Enterprise Organization",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % QUOTES.length), 7000);
    return () => clearInterval(t);
  }, []);

  const q = QUOTES[i];

  return (
    <section
      data-testid="testimonials-section"
      className="theme-editorial relative bg-[#111] text-white py-28 md:py-40 overflow-hidden"
      aria-label="Customer outcomes"
    >
      <div aria-hidden className="absolute inset-0 grid-editorial opacity-[0.04]" style={{ backgroundSize: "72px 72px", backgroundImage: "linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)" }} />
      <div aria-hidden className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(245,184,65,0.10),transparent_70%)]" />

      <div className="relative z-10 mx-auto max-w-[1180px] px-6 md:px-10">
        <div className="font-mono text-[10px] tracking-[0.32em] text-[#F5B841] mb-6">
          [ CUSTOMER · OUTCOMES ]
        </div>

        <div className="min-h-[260px] md:min-h-[300px]">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="font-editorial-display text-[32px] md:text-[54px] leading-[1.08] tracking-[-0.022em] max-w-[1100px]"
            >
              <span className="text-[#F5B841] font-editorial-italic">“</span>
              {q.q}
              <span className="text-[#F5B841] font-editorial-italic">”</span>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <div className="font-editorial-display text-[18px] text-white/95">— {q.a}</div>
            <div className="font-mono text-[10px] tracking-[0.28em] text-white/60 mt-1">
              {q.org.toUpperCase()}
            </div>
          </div>
          <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.28em] text-white/60">
            <span>{String(i + 1).padStart(2, "0")} / {String(QUOTES.length).padStart(2, "0")}</span>
            <div className="flex gap-1">
              {QUOTES.map((_, j) => (
                <button
                  key={j}
                  data-testid={`testimonial-dot-${j}`}
                  onClick={() => setI(j)}
                  aria-label={`Quote ${j + 1}`}
                  className={`h-1 w-6 ${j === i ? "bg-[#F5B841]" : "bg-white/25"} transition-colors`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
